module.exports = __webpack_public_path__ + "images/FUSA_icons/072-email.dbab50302d22fe83a7e6e55ffa10c678.svg";